import fetch from '@/utils/fetch'

export function loadInfo (id) {
  return fetch({
    url: `/website/retail/industry/info/${id}`,
    method: 'post'
  })
}

export function goodsList (id, data) {
  return fetch({
    url: `/website/retail/industry/${id}/goods-list`,
    method: 'post',
    data
  })
}

// 获取评论
export function loadCommentList (data) {
  return fetch({
    url: '/website/order-review/page',
    method: 'post',
    data
  })
}

// 加入购物车
export function addToCart (data) {
  return fetch({
    url: '/website/cart/add',
    method: 'post',
    data
  })
}
